import { CheckCircle2, Clock3, Wallet } from "lucide-react";
import { EmptyState, FieldRow, SectionCard, statusBadge } from "@/components/coverage/coverageUi";

export default function VisitReadinessPanel({ workspace }) {
  const period = workspace.coverage_period
    ? `${workspace.coverage_period.start || "?"} → ${workspace.coverage_period.end || "?"}`
    : "Not provided";

  return (
    <div className="space-y-4" data-testid="coverage-visit-panel">
      <div className="grid md:grid-cols-2 gap-4">
        <SectionCard title="Visit readiness" icon={<CheckCircle2 className="w-4 h-4 text-emerald-400" />}>
          <FieldRow label="Coverage" value={statusBadge(workspace.coverage_status)} />
          <FieldRow label="Plan" value={workspace.plan_name} />
          <FieldRow label="Member ID" value={workspace.member_id} />
          <FieldRow label="Group" value={workspace.group_number} />
          <FieldRow label="Network" value={workspace.network_status} />
          <FieldRow label="Period" value={period} />
          <FieldRow label="DOB" value={workspace.date_of_birth} />
          <FieldRow label="Visit reason" value={workspace.reason_for_visit} />
          <FieldRow label="Planned" value={(workspace.planned_services || []).join(", ")} />
          <FieldRow
            label="Provider"
            value={`${workspace.provider_name || "Not provided"} · NPI ${workspace.provider_npi || "—"}`}
          />
        </SectionCard>

        <SectionCard title="Annual max & deductible" icon={<Wallet className="w-4 h-4 text-emerald-400" />}>
          <FieldRow label="Deductible" value={workspace.deductible} />
          <FieldRow label="Remaining deductible" value={workspace.remaining_deductible} />
          <FieldRow label="Annual maximum" value={workspace.annual_maximum} />
          <FieldRow label="Remaining maximum" value={workspace.remaining_maximum} />
          <FieldRow label="Copay" value={workspace.copay} />
          <FieldRow label="Coinsurance" value={workspace.coinsurance} />
          <FieldRow label="Plan member cost" value={workspace.plan_member_cost} />
          {(workspace.financial_notes || []).map((note, idx) => (
            <p key={idx} className="text-xs text-slate-500 pt-1">
              {note}
            </p>
          ))}
        </SectionCard>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <SectionCard title="Waiting periods" icon={<Clock3 className="w-4 h-4 text-amber-400" />}>
          {!workspace.waiting_periods?.length ? (
            <EmptyState title="No waiting-period details from Stedi or benefits_summary" />
          ) : (
            workspace.waiting_periods.map((row, idx) => (
              <div key={idx} className="border-b border-slate-800/80 pb-2 text-sm text-slate-300">
                <p>{row.text}</p>
                {row.quantity ? <p className="text-xs text-slate-500">{row.quantity}</p> : null}
              </div>
            ))
          )}
        </SectionCard>

        <SectionCard title="Frequency remaining">
          {!workspace.frequency_limits?.length ? (
            <EmptyState title="No frequency remaining / procedure frequency on this payload" />
          ) : (
            workspace.frequency_limits.map((row, idx) => (
              <div key={idx} className="text-sm">
                <FieldRow label={row.label} value={row.remaining ? `${row.value} · remaining ${row.remaining}` : row.value} />
              </div>
            ))
          )}
        </SectionCard>
      </div>

      <SectionCard title="Coordination of benefits">
        {!workspace.cob?.present ? (
          <EmptyState title="No COB flags on this payload" />
        ) : (
          workspace.cob.fields.map((field) => (
            <FieldRow key={field.label} label={field.label} value={field.value} />
          ))
        )}
      </SectionCard>
    </div>
  );
}
